module.exports = __webpack_public_path__ + "img/icon_ksjxspslt.b7bb4df8.png";